import React from "react";
import {useEffect, useState} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import {
    Alert, Button,
    Card, CircularProgress, Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Fab, FormControlLabel, Grid,
    IconButton,
    Snackbar
} from "@mui/material";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import styles from "../../../assets/css/page.module.scss";
import CustomTable from "../../../components/subComponents/Table";
import {CustomerApi} from "../../../utils/CustomerApi";
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import {TextField} from "../../../components/subComponents/TextField";
import LoadingButton from "../../../components/subComponents/LoadingButton";
import {styled} from "@mui/material/styles";
import {useRef} from "react";
import configs from "../../../utils/config.json";
import IOSSwitch from "../../../components/subComponents/IOSSwitch";

const fabStyle = {
    position: 'absolute',
    top: 30,
    right: 30,
};
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

const Input = styled('input')({
    display: 'none',
});
const Customer = (props) => {
    const params = useParams();
    const navigate = useNavigate();
    const ref = useRef();
    const ref2 = useRef();
    const [rows, setRows] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [openSnackBar1, setOpenSnackBar1] = useState(false);
    const [message, setMessage] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [imageLoading, setImageLoading] = useState(false);
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [sending, setSending] = useState(false);
    const sendDataToServer = async () => {
        setSending(true);

        if (params.id) {
            const update = async () => {
                let fd = new FormData();
                fd.append("payload", JSON.stringify({
                    name: name,
                    description: description,
                }));
                if (ref.current.files.length)
                    fd.append("photo", ref.current.files[0]);
                if (ref2.current.files.length)
                    fd.append("icon", ref2.current.files[0]);
                await CustomerApi.updateCustomer(fd, params.id,
                    async (result) => {
                        handleClickSnackBar1("مشتری بروزرسانی شد.");
                        await sleep(3000);
                        setSending(false);
                        navigate("/admin/customer");
                        fetchData();

                    },
                    (error) => {
                        setSending(false);

                    });
            }
            await update();
        } else {
            const insert = async () => {
                let fd = new FormData();
                fd.append("payload", JSON.stringify({
                    name: name,
                    description: description,
                }));
                if (ref.current.files.length)
                    fd.append("photo", ref.current.files[0]);

                if (ref2.current.files.length)
                    fd.append("icon", ref2.current.files[0]);
                await CustomerApi.insertCustomer(fd,
                    async (result) => {
                        handleClickSnackBar1("مشتری افزوده شد.");
                        await sleep(3000);
                        setSending(false);
                        handleClose();
                        fetchData();
                    },
                    (error) => {
                        setSending(false);

                    });
            }
            await insert();
        }

    }

    const handleClickSnackBar1 = (text) => {
        setOpenSnackBar1(true);
        setMessage(text);
    };
    const handleCloseSnackBar1 = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackBar1(false);
    };

    const handleClose = () => {
        setOpenDialog(false);
    };


    const activate = async (id) => {
        await CustomerApi.activate(id, (result) => {
            fetchData();
            handleClickSnackBar1('مشتری فعال شد!');

        }, (error) => {
        });
    }
    const deactivate = async (id) => {
        await CustomerApi.deactivate(id, (result) => {
            fetchData();
            handleClickSnackBar1('مشتری غیرفعال شد!');

        }, (error) => {
        });
    }

    const deleteCustomer = async (id) => {
        setDataLoading(true);
        await CustomerApi.deleteCustomer(id, () => {
            handleClickSnackBar1('مشتری حذف شد!');
            fetchData();

        }, () => {
        });
    }
    const fetchData = async () => {
        setDataLoading(true);
        await CustomerApi.getCustomers(
            (result) => {
                setRows(result.data);
                setDataLoading(false);
            },
            (error) => {
                setDataLoading(false);

            });

    }
    const headers = [
        {
            field: 'title', title: 'نام', width: 250, renderCell: (row) => (
                <div>
                    <Link to={`/admin/customer/${row.id}`}>{row.name}</Link>
                </div>
            ),
        },


        {
            field: 'userStatus', title: 'تصویر', width: 400,
            align: 'right',
            renderCell: (row) => (
                <>
                    <img src={`${configs.server.Storage}/${row.img}`} style={{width: 200, borderRadius: 10}} alt={""}/>

                </>)
        },
        {
            field: 'userStatus', title: '---', width: 200,
            align: 'right',
            renderCell: (row) => (
                <>
                    <IconButton color="error" component="button" onClick={() => {
                        (async () => {
                            await deleteCustomer(row.id);
                        })();
                    }}>
                        <DeleteOutlineRoundedIcon/>
                    </IconButton>

                </>)
        },

        {
            field: 'userStatus', title: 'وضعیت نمایش', width: 100,
            align: 'right',
            renderCell: (row) => (
                <>
                    <FormControlLabel
                        className={styles.switch}
                        control={<IOSSwitch sx={{m: 1}}
                                            defaultChecked={parseInt(row.active) === 1}
                                            onChange={e => {
                                                if (e.target.checked)
                                                    (async () => {
                                                        await activate(row.id);
                                                    })();
                                                else (async () => {
                                                    await deactivate(row.id);
                                                })();
                                            }}
                        />}
                        label=""
                    />

                </>)
        },
    ];

    const getCustomer = async (id) => {
        await CustomerApi.getCustomer(id, (result) => {
            setName(result.data.name);
            setDescription(result.data.description);
            document.getElementById("img1").setAttribute("src", `${configs.server.Storage}/${result.data.img}`);
            document.getElementById("img2").setAttribute("src", `${configs.server.Storage}/${result.data.icon}`);

        }, (error) => {
        })
    }

    useEffect(() => {
        (async () => {
            await fetchData();
        })();


    }, []);
    useEffect(() => {
        if (params.id) {
            (async () => {
                await getCustomer(params.id);
            })();
        } else {
            setName("");
            setDescription("");
            // document.getElementById("img1").setAttribute("src", `https://ndb-soft.com/wp-content/uploads/2020/06/placeholder.png`);
            // document.getElementById("img2").setAttribute("src", `https://ndb-soft.com/wp-content/uploads/2020/06/placeholder.png`);
        }
    }, [params.id]);

    return <div style={{padding: 15}}>
        <Card elevation={3} style={{height: 'calc(100vh - 30px)', direction: "rtl", overflow: "hidden"}}>
            <div className={styles.container}>
                <CustomTable headers={headers} rows={rows} loading={dataLoading} bottom={0}/>

            </div>
        </Card>
        <Dialog
            fullWidth
            maxWidth={"md"}
            open={(openDialog || params.id)}
            onClose={handleClose}
        >
            <DialogTitle>{params.id ? 'بروزرسانی مشتری' : 'ایجاد مشتری جدید'}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                </DialogContentText>
                <Grid container spacing={8}>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={6}>
                                <div className={styles.inputContainer}>
                                    <TextField label="نام" variant="outlined"
                                               value={name}
                                               onChange={e => {
                                                   setName(e.target.value)
                                               }}
                                               fullWidth
                                    />
                                </div>
                                <div className={styles.inputContainer}>

                                    <TextField label="شرح" variant="outlined"
                                               multiline
                                               rows={10}
                                               value={description}
                                               onChange={e => {
                                                   setDescription(e.target.value)
                                               }}
                                               fullWidth

                                    />
                                </div>
                            </Grid>


                            <Grid item xs={6}>
                                <div style={{display: "flex", flexDirection: "column"}}>
                                    <div style={{
                                        width: "100%",
                                        borderRadius: 15,
                                        margin: 15,
                                        overflow: "hidden",
                                        position: "relative",
                                        height: 200
                                    }}>
                                        <img id={"img1"}
                                             style={{
                                                 width: "100%",
                                                 position: "absolute",
                                                 top: 0,
                                                 height: "100%",
                                                 zIndex: 1
                                             }}
                                             alt={""}
                                             src={'https://ndb-soft.com/wp-content/uploads/2020/06/placeholder.png'}/>
                                        <div style={{
                                            top: 130,
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            position: "absolute",
                                            zIndex: 2
                                        }}>
                                            {imageLoading && <CircularProgress/>}
                                        </div>
                                    </div>


                                    <label htmlFor="img"
                                           style={{
                                               display: "flex",
                                               flexDirection: "column",
                                               justifyContent: "center",
                                               width: "100%",
                                               margin: 15
                                           }}>
                                        <Input accept="image/*" multiple type="file" ref={ref} id={"img"}
                                               onChange={e => {
                                                   setImageLoading(true);
                                                   let files = e.target.files; // FileList object

                                                   // use the 1st file from the list
                                                   let f = files[0];

                                                   let reader = new FileReader();
                                                   // Closure to capture the file information.
                                                   reader.onload = (function (theFile) {
                                                       return function (e) {
                                                           document.getElementById("img1").setAttribute("src", this.result);

                                                           setImageLoading(false);
                                                           console.log("image loaded!!")
                                                       };
                                                   })(f);

                                                   // Read in the image file as a data URL.
                                                   reader.readAsDataURL(f);
                                               }}/>
                                        <Button variant="contained" component="span">
                                            آپلود تصویر
                                        </Button>
                                    </label>
                                </div>
                                <div style={{display: "flex", flexDirection: "column"}}>
                                    <div style={{
                                        width: 100,
                                        margin: 15,
                                        overflow: "hidden",
                                        position: "relative",
                                        height: 100
                                    }}>
                                        <img id={"img2"}
                                             style={{
                                                 borderRadius: 15,
                                                 width: "100px",
                                                 position: "absolute",
                                                 top: 0,
                                                 height: "100px",
                                                 zIndex: 1
                                             }}
                                             alt={""}
                                             src={'https://ndb-soft.com/wp-content/uploads/2020/06/placeholder.png'}/>
                                        <div style={{
                                            top: 30,
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            position: "absolute",
                                            zIndex: 2
                                        }}>
                                            {imageLoading && <CircularProgress/>}
                                        </div>
                                    </div>


                                    <label htmlFor="img3"
                                           style={{
                                               display: "flex",
                                               flexDirection: "column",
                                               justifyContent: "center",
                                               width: "100%",
                                               margin: 15
                                           }}>
                                        <Input accept="image/*" multiple type="file" ref={ref2} id={"img3"}
                                               onChange={e => {
                                                   setImageLoading(true);
                                                   let files = e.target.files; // FileList object

                                                   // use the 1st file from the list
                                                   let f = files[0];

                                                   let reader = new FileReader();
                                                   // Closure to capture the file information.
                                                   reader.onload = (function (theFile) {
                                                       return function (e) {
                                                           document.getElementById("img2").setAttribute("src", this.result);

                                                           setImageLoading(false);
                                                           console.log("image loaded!!")
                                                       };
                                                   })(f);

                                                   // Read in the image file as a data URL.
                                                   reader.readAsDataURL(f);
                                               }}/>
                                        <Button variant="contained" component="span">
                                            آپلود تصویر
                                        </Button>
                                    </label>
                                </div>

                            </Grid>

                            <Grid item xs={12}>

                            </Grid>
                            <Grid item xs={12}>

                            </Grid>

                        </Grid>


                    </Grid>
                </Grid>

            </DialogContent>
            <DialogActions>
                <Button color="error" onClick={() => {
                    if (params.id)
                        navigate(-1);
                    else handleClose();
                }}>
                    انصراف
                </Button>

                <LoadingButton
                    loading={sending}
                    loadingPosition="end"
                    variant={'text'}
                    color="primary"
                    component="button"
                    onClick={() => {
                        sendDataToServer();
                    }}
                >
                    ثبت
                </LoadingButton>
            </DialogActions>
        </Dialog>
        <Snackbar open={openSnackBar1} autoHideDuration={2000}
                  onClose={handleCloseSnackBar1}
                  className={styles.snackBar}
                  anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
        >
            <Alert
                severity="success"
                className={styles.txt}
            >
                {message}
            </Alert>
        </Snackbar>

        <Fab sx={fabStyle} color="primary" onClick={() => {
            setOpenDialog(true)
        }}>
            <AddRoundedIcon/>
        </Fab>
    </div>;
}

export default Customer;